var $abb4ac28efcaa60c$exports = {};
// Shared navigation logic: menu toggle + active link highlighting
function $abb4ac28efcaa60c$var$normalizeCurrentPath() {
    try {
        let current = window.location.pathname.split('/').pop() || '';
        if (!current) current = 'index.html';
        if (current.indexOf('.') === -1) current = current + '.html';
        return current;
    } catch (_) {
        return 'index.html';
    }
}
function $abb4ac28efcaa60c$var$highlightCurrentLink(menu) {
    if (!menu) return;
    try {
        const links = menu.querySelectorAll('a');
        const current = $abb4ac28efcaa60c$var$normalizeCurrentPath();
        links.forEach((a)=>a.classList.remove('current'));
        for (const a of Array.from(links)){
            const href = (a.getAttribute('href') || '').split('/').pop() || '';
            if (!href) continue;
            if (href === current || current === 'index.html' && (href === '/' || href === 'index.html')) {
                a.classList.add('current');
                break;
            }
        }
    } catch (_) {
    // no-op
    }
}
function $abb4ac28efcaa60c$var$setupMenuToggle(menuBtn, menu) {
    if (!menuBtn || !menu) return;
    menuBtn.addEventListener('click', function() {
        menu.classList.toggle('active');
    });
    // Hide menu when clicking outside on small screens
    document.addEventListener('click', function(e) {
        if (window.innerWidth <= 950 && menu.classList.contains('active')) {
            const target = e.target;
            if (!menu.contains(target) && !menuBtn.contains(target)) menu.classList.remove('active');
        }
    });
}
function $abb4ac28efcaa60c$var$initNav() {
    const menuBtn = document.querySelector('.menu-toggle');
    const menu = document.getElementById('templatemo-menu');
    $abb4ac28efcaa60c$var$setupMenuToggle(menuBtn, menu);
    $abb4ac28efcaa60c$var$highlightCurrentLink(menu);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $abb4ac28efcaa60c$var$initNav);
else $abb4ac28efcaa60c$var$initNav();


//# sourceMappingURL=about.04d72326.js.map
